export const convertToSeconds = (time: string) => {
  const [hours, minutes, seconds] = time.split(":").map(Number)
  return hours * 3600 + minutes * 60 + seconds
}

export const sumDuration = (times: string[]) => {
  const totalSeconds = times.reduce((acc, time) => acc + convertToSeconds(time), 0)
  return totalSeconds
}
